module.exports = __webpack_public_path__ + "static/media/6.10.1bc33e83.zip";